<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';

defineProps<{
  text?: string;
}>();
</script>

<template>
  <Button variant="text" :label="text ?? $t('Cancel')" />
</template>
